import { render } from "./DeleteTagTemplates.vue?vue&type=template&id=48ecbe64"
import script from "./DeleteTagTemplates.vue?vue&type=script&lang=js"
export * from "./DeleteTagTemplates.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__